import { useTranslation } from 'react-i18next';

import { I18NextNS } from 'src/models/Language.model';

import partyIcon from '../../../assets/icons/party.svg';
import InfoCardTemplate from './InfoCardTemplate';

export default function GradableInfoCard() {
  const { t } = useTranslation(I18NextNS.PAGES, {
    keyPrefix: 'newExam.analyzingModal.infoCards.gradable',
  });

  return (
    <InfoCardTemplate
      icon={<img src={partyIcon} alt="Success" />}
      backgroundColor="success-100"
      borderColor="success"
      primaryText={t('primary')}
      secondaryText={t('secondary')}
      dataTest="info-gradable"
    />
  );
}
